<template>
  <div class="perfil-page">
    <div class="container q-py-xl">
      <div class="row justify-center" >
        <div class="col-12 col-md-8 col-lg-6">
          <!-- Card Principal do Perfil -->
          <q-card flat bordered class="perfil-card" style="margin-top: 30px;">
            <!-- Header com Foto e Informações Básicas -->
            <q-card-section class="text-center q-pt-xl q-pb-lg bg-gradient">
              <q-avatar size="120px" class="profile-avatar q-mb-md"  v-if="user.photo">
                <img :src="user.photo" alt="Foto de perfil">
                
              </q-avatar>
              <q-avatar size="120px" class="profile-avatar q-mb-md" v-else>
                <img src="../../assets/icon2.png" alt="Foto de perfil">
              </q-avatar>
              
              <h5 class="text-h5 text-weight-bold text-grey-9 q-mb-xs q-mt-md">
                {{ user.name }}
              </h5>
              
              <div class="row items-center justify-center q-mb-sm">
                <q-icon name="mail" size="18px" color="grey-6" />
                <span class="text-body2 text-grey-7 q-ml-xs">
                  {{ user.email }}
                </span>
              </div>

              <q-chip 
                icon="verified_user" 
                color="primary" 
                text-color="white"
                size="sm"
              >
                Conta Verificada
              </q-chip>
            </q-card-section>

            <q-separator />

            <!-- Menu de Opções -->
            <q-card-section class="q-pa-md">
              <div class="opcoes-menu">
                <!-- Atualizar Informações -->
                <q-item 
                  clickable 
                  v-ripple 
                  class="menu-item"
                  @click="navegarPara('update-profile')"
                >
                  <q-item-section avatar>
                    <q-avatar color="blue-1" text-color="blue-7" icon="person" />
                  </q-item-section>

                  <q-item-section>
                    <q-item-label class="text-weight-medium">
                      Atualizar Informações Pessoais
                    </q-item-label>
                    <q-item-label caption class="text-grey-6">
                      Edite seu nome, email e outros dados
                    </q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-icon name="chevron_right" color="grey-5" />
                  </q-item-section>
                </q-item>

                <q-separator spaced />

                <!-- Alterar Senha -->
                <q-item 
                  clickable 
                  v-ripple 
                  class="menu-item"
                  @click="navegarPara('ChangePassword')"
                >
                  <q-item-section avatar>
                    <q-avatar color="orange-1" text-color="orange-7" icon="lock" />
                  </q-item-section>

                  <q-item-section>
                    <q-item-label class="text-weight-medium">
                      Alterar Senha
                    </q-item-label>
                    <q-item-label caption class="text-grey-6">
                      Atualize sua senha de acesso
                    </q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-icon name="chevron_right" color="grey-5" />
                  </q-item-section>
                </q-item>

                <q-separator spaced />

                <!-- Logout -->
                <q-item 
                  clickable 
                  v-ripple 
                  class="menu-item logout-item"
                  @click="fazerLogout"
                >
                  <q-item-section avatar>
                    <q-avatar color="red-1" text-color="red-7" icon="logout" />
                  </q-item-section>

                  <q-item-section>
                    <q-item-label class="text-weight-medium text-red-7">
                      Sair da Conta
                    </q-item-label>
                    <q-item-label caption class="text-grey-6">
                      Encerrar sua sessão atual
                    </q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-icon name="chevron_right" color="grey-5" />
                  </q-item-section>
                </q-item>
              </div>
            </q-card-section>

            <!-- Informações Adicionais -->
            <q-separator />
            
            <q-card-section class="q-pa-md bg-grey-1">
              <div class="row q-col-gutter-md">
                <div class="col-12">
                  <div class="info-box text-center">
                    <q-icon name="calendar_today" size="24px" color="primary" />
                    <div class="text-caption text-grey-7 q-mt-xs">Membro desde</div>
                    <div class="text-body2 text-weight-bold">{{ user.created_at }}</div>
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import store from '@/vuex/store';

const router = useRouter();
const $q = useQuasar();
const user = ref({
  name: '',
  email: '',
  created_at: '',
  photo: ''
})

// Dados do usuário (podem vir do Vuex/store)
// const usuario = ref({
//   nome: 'Maria Santos',
//   email: 'maria.santos@email.com',
//   foto: '../../assets/icon2.png'
// });

// Função para navegar para outras rotas
const navegarPara = (rota) => {
  router.push({ name: rota });
};
onMounted(() => {
  user.value = store.state.auth.user ? store.state.auth.user : {
    name: '',
    email: '',
    created_at: ''
  };
})
watch(
  () => store.state.auth.user,
  (novoUsuario) => {
    if (novoUsuario) {
      user.value = novoUsuario;
    }
  }
);
// const user = computed(() => {
//   return store.state.auth.user;
// });
// Função de logout
const fazerLogout = () => {
  $q.dialog({
    title: 'Confirmar Saída',
    message: 'Tem certeza que deseja sair da sua conta?',
    cancel: {
      label: 'Cancelar',
      flat: true,
      color: 'grey-7'
    },
    ok: {
      label: 'Sair',
      color: 'red-7',
      unelevated: true
    },
    persistent: true
  }).onOk(() => {
    // Limpar dados de autenticação
    // localStorage.removeItem('token');
    // store.dispatch('auth/logout');
    
    
    
    // Redirecionar para login
    router.push('/');
  });
};
</script>

<style scoped>
.perfil-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px;
}

.perfil-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.bg-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: white;
}

.profile-avatar {
  border: 4px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
}

.status-badge {
  bottom: 8px;
  right: 8px;
}

.menu-item {
  border-radius: 12px;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.menu-item:hover {
  background: #f5f5f5;
  transform: translateX(4px);
}

.logout-item:hover {
  background: #ffebee;
}

.opcoes-menu {
  padding: 8px 0;
}

.info-box {
  padding: 16px;
  border-radius: 12px;
  background: white;
  transition: all 0.3s ease;
}

.info-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 599px) {
  .profile-avatar {
    width: 100px !important;
    height: 100px !important;
  }
  
  .text-h5 {
    font-size: 1.25rem;
  }
}
</style>